import styled from 'styled-components';

export const SearchContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.md};
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
  margin-bottom: ${props => props.theme.spacing.md};
`;

export const StyledSearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.colors.backgroundSecondary};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.md};
  padding: 0 12px;
  width: 100%;
  flex: 1;
  min-width: 300px;
  transition: all 0.2s ease;
  max-width: 400px;

  &:focus-within {
    border-color: ${props => props.theme.colors.tint};
    box-shadow: 0 0 0 3px ${props => props.theme.colors.tint}20;
  }
`;

export const SearchIcon = styled.span`
  font-size: 16px;
  opacity: 0.5;
  margin-right: 8px;
  display: flex;
  align-items: center;
  user-select: none;
`;

export const TransparentInput = styled.input`
  border: none;
  background: none;
  outline: none;
  width: 100%;
  padding: 12px 0;
  color: ${props => props.theme.colors.text};
  font-size: ${props => props.theme.typography.sizes.default};

  &::placeholder {
    color: ${props => props.theme.colors.muted};
  }
`;
